/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./themeColor.vue?vue&type=template&id=ad95c560&scoped=true"
import script from "./themeColor.vue?vue&type=script&lang=js"
export * from "./themeColor.vue?vue&type=script&lang=js"
import style0 from "./themeColor.vue?vue&type=style&index=0&id=ad95c560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad95c560",
  null
  
)

export default component.exports